import {
  User,
  Branch,
  Area,
  Zone,
  Bank,
  RecoveryDepartment,
  CommissionRule,
  UserCommissionAssignment,
  CommissionAuditLog,
  Account,
  AccountAllocation,
  AllocationHistory,
  FollowUp,
  PTPRecord,
  RecoveryRecord,
  FieldVisit,
  PhotoRecord,
  VoiceNoteRecord,
  DocumentRecord,
  ActivityLog,
  NotificationItem,
  CommissionRecord,
  CommissionSettings,
} from '../types';
// ---------------------------------------------------------------------
// Seed data.
//
// Every collection is EMPTY on purpose. Real data lives in Cloud Firestore
// and arrives through the real-time listeners in SRMSContext.
//
// No password, hash or salt is shipped in this file. Authentication is
// handled entirely by Firebase Auth; credentials are never bundled into
// the client, where anyone could read them from the JavaScript bundle.
// ---------------------------------------------------------------------

export const initialBanks: Bank[] = [];

export const initialZones: Zone[] = [];

export const initialRecoveryDepartments: RecoveryDepartment[] = [];

export const initialAreas: Area[] = [];

export const initialBranches: Branch[] = [];

/**
 * Placeholder shown for the split second between app start and the Firebase
 * Auth state resolving. It carries NO credentials and NO real identity --
 * the signed-in profile replaces it as soon as Firestore responds.
 */
export const placeholderUser: User = {
  id: 'PENDING',
  username: '',
  loginId: '',
  name: 'Signing in…',
  email: '',
  role: 'agent',
  mobile: '',
  joiningDate: '',
  active: true,
  status: 'PENDING',
  branch: '',
  area: '',
  zone: '',
  tokenVersion: 1,
};

export const initialUsers: User[] = [placeholderUser];

export const initialCommissionRules: CommissionRule[] = [];
export const initialUserCommissionAssignments: UserCommissionAssignment[] = [];
export const initialCommissionAuditLogs: CommissionAuditLog[] = [];

export const initialCommissionSettings: CommissionSettings = {
  defaultRate: 10.0, // Default 10%
  minimumPayoutAmount: 500,
  autoApprovalThreshold: 25000,
};

export const initialAccounts: Account[] = [];
export const initialAccountAllocations: AccountAllocation[] = [];
export const initialAllocationHistories: AllocationHistory[] = [];
export const initialFollowUps: FollowUp[] = [];
export const initialPTPs: PTPRecord[] = [];
export const initialRecoveries: RecoveryRecord[] = [];
export const initialVisits: FieldVisit[] = [];
export const initialPhotos: PhotoRecord[] = [];
export const initialVoiceNotes: VoiceNoteRecord[] = [];
export const initialDocuments: DocumentRecord[] = [];
export const initialCommissions: CommissionRecord[] = [];
export const initialActivityLogs: ActivityLog[] = [];
export const initialNotifications: NotificationItem[] = [];
